"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  data: function data() {
    return {
      recordTxt: process.env.VUE_APP_RECORD_TXT,
      recordNumber: process.env.VUE_APP_RECORD_NUMBER
    };
  },
  methods: {}
};